import { BehaviorSubject } from "rxjs/Rx";
import { Component } from '@angular/core';
import { Events, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { OrderPage } from '../order/order';
import { PosmSubitemDescriptionPage } from '../posm-subitem-description/posm-subitem-description';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { OrderDetail } from '../../models/order-detail.model';

import { OrderProvider } from "../../providers/order/order";

import { LoginPage } from '../auth/login';

@IonicPage()
@Component({
  selector: 'page-order-detail',
  templateUrl: 'order-detail.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class OrderDetailPage {

  protected orderDetail: OrderDetail = undefined;

  private orderId: number;

  public inOrderDetail: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public loading: boolean;

  posmSubitemDescription: PosmSubitemDescriptionPage;

  constructor(public storage: Storage, public events: Events, public orderProvider: OrderProvider, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, public modalCtrl: ModalController) {
    this.posmSubitemDescription = new PosmSubitemDescriptionPage(storage, navCtrl, navParams, translate, modalCtrl);

    if(!this.navParams.get('orderId')) {
      this.navCtrl.pop();
    }

    this.orderId = this.navParams.get('orderId');

    this.inOrderDetail.subscribe((inOrderDetail) => {
      if(!inOrderDetail) {
        this.getOrderDetail();
      }
    });
  }

  private getOrderDetail() {
    this.loading = true;
    this.orderProvider.getOrderDetail(this.orderId)
      .subscribe(
        order => this.orderDetail = order,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.closeModal();
          this.loading = false;
        },
        () => {
          if (this.orderDetail) {
            switch(this.orderDetail.status) {
              case "WAITING":
                this.orderDetail.status_value = 1;
                break;
              case "CONFIRMED":
                this.orderDetail.status_value = 2;
                break;
              case "SENT":
                this.orderDetail.status_value = 3;
                break;
              default:
                this.orderDetail.status_value = 0;
                break;
            }

            if (this.orderDetail.notification == true) {
              this.orderProvider.notificationOff(this.orderId).subscribe(
                () => {
                  this.loading = false;
                }
              );
            } else {
              this.loading = false;
            }
          } else {
            this.loading = false;
          }
        }
      );
  }

  closeModal() {
    this.navCtrl.pop();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  protected reloadOrderDetailContent (refresher) {
    this.getOrderDetail();
    refresher.complete();
  }

  protected editOrder() {

    this.storage.get('current_brand').then((brand) => {
      let tosModal = this.modalCtrl.create(OrderPage, {
        orderId: this.orderDetail.id,
        shopName: this.orderDetail.shop_name || '',
        deliveryName: this.orderDetail.delivery_name,
        deliveryAddress: this.orderDetail.delivery_address,
        number: this.orderDetail.number,
        comments: this.orderDetail.comments || '',
        editOrder: true,
        orderType: "delivery",
      }, { cssClass: brand.name });
      tosModal.present();
      tosModal.onDidDismiss(() => {
        this.events.publish('orderList:get_data');
        this.inOrderDetail.next(false);
      });
    });
  }


  protected cancelOrder() {
    this.loading = false;
    this.events.publish('orderList:get_data');
    this.orderProvider.cancelOrder(this.orderId).subscribe(
      () => {
        this.loading = false;
        this.dismiss();
      }
    );
  }

  protected receivedOrder() {
    this.events.publish('orderList:get_data');
    this.orderProvider.receivedOrder(this.orderId).subscribe(
      () => {
        this.getOrderDetail();
      }
    );
  }

  sendPurchase(orderId) {
    this.orderProvider.sendPurchase(orderId).subscribe(
      () => {
        this.getOrderDetail();
      }
    );
  }

  canGetPurchase(orderStatus) {
    if (orderStatus === 'CONFIRMED'
    || orderStatus === 'SENT'
    || orderStatus === 'RECEIVED') {
      return true;
    }
    return false;
  }

  getManagerMailSender(mail) {
    return "mailto:" + mail;
  }

  orderStatusColor(statusValue) {
    let color;
    switch(statusValue) {
      case 'WAITING':
        color = 'dark';
        break;
      case 'CONFIRMED':
        color = 'success';
        break;
      case 'SENT':
        color = 'light';
        break;
      case 'RECEIVED':
        color = 'success';
        break;
      case 'REFUSED':
        color = 'default-purple';
        break;
      case 'CANCELED':
        color = 'danger';
        break;
    }
    return color;
  }

  orderPosmSubitemStatusColor(statusValue) {
    let color;
    switch(statusValue) {
      case 'VALID':
        color = 'success';
        break;
      case 'MODIFIED':
        color = 'secondary';
        break;
      case 'REFUSED':
        color = 'default-purple';
        break;
      case 'INVALID':
        color = 'warning';
        break;
    }
    return color;
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-detail/order-detail.ts